/**
 * Private seat credentials live in this browser only. They are never put in the
 * URL, so sharing a room link never shares a seat.
 */
export interface StoredSeat {
  playerId: string;
  resumeToken: string;
  name: string;
}

const key = (roomId: string): string => `lafayette:seat:${roomId}`;

export function readSeat(roomId: string): StoredSeat | null {
  try {
    const raw = localStorage.getItem(key(roomId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredSeat>;
    if (!parsed.playerId || !parsed.resumeToken) return null;
    return { playerId: parsed.playerId, resumeToken: parsed.resumeToken, name: parsed.name ?? '' };
  } catch {
    return null;
  }
}

export function writeSeat(roomId: string, seat: StoredSeat): void {
  try {
    localStorage.setItem(key(roomId), JSON.stringify(seat));
  } catch {
    // A browser with storage disabled simply cannot auto-resume.
  }
}

export function clearSeat(roomId: string): void {
  try {
    localStorage.removeItem(key(roomId));
  } catch {
    // ignore
  }
}

export function readPreferredName(): string {
  try {
    return localStorage.getItem('lafayette:name') ?? '';
  } catch {
    return '';
  }
}

export function writePreferredName(name: string): void {
  try {
    localStorage.setItem('lafayette:name', name);
  } catch {
    // ignore
  }
}
